import { render, staticRenderFns } from "./LocationTopicResponsibleTable.vue?vue&type=template&id=f104722a&scoped=true"
import script from "./LocationTopicResponsibleTable.vue?vue&type=script&lang=ts"
export * from "./LocationTopicResponsibleTable.vue?vue&type=script&lang=ts"
import style0 from "./LocationTopicResponsibleTable.vue?vue&type=style&index=0&id=f104722a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f104722a",
  null
  
)

export default component.exports